import { useCallback } from 'react';

import { useInstanceCallback } from '@/scenarios/legacy-player/hooks/useInstanceCallback';

import { SEEK_INTERVAL } from '../../constants/skin';

import { useSeekWithIndicator } from './use-seek-with-indicator';

export const useRestrictedSeekWithIndicator = () => {
    const {
        seekBackward: seekBackwardUnrestricted,
        seekForward: seekForwardUnrestricted,
        ...rest
    } = useSeekWithIndicator();

    /** @see OTT-82541 if need hide preroll timeline */
    const prerollDuration = 0;

    const seekBackward = useInstanceCallback(
        (instance) => {
            if (
                !instance?.currentTime ||
                instance.currentTime - SEEK_INTERVAL >= (prerollDuration ?? 0)
            ) {
                seekBackwardUnrestricted(SEEK_INTERVAL);
            }
        },
        [prerollDuration, seekBackwardUnrestricted]
    );

    const seekForward = useCallback(
        () => seekForwardUnrestricted(SEEK_INTERVAL),
        [seekForwardUnrestricted]
    );

    return { seekBackward, seekForward, ...rest };
};
